import React from "react";
import { useSelector } from "react-redux";
import { Route, Redirect } from "react-router-dom";

import { PATHS } from "App/router";
import { isUserAuthenticatedSelector } from "Auth/state";

export interface PrivateRouteProps {
  component: React.ComponentType<any>;
}

/*
  This component redirects to the login page when the user is not authenticated.
  The path the user was trying to access is added to the state so the user can be redirected 
  back to that page when they login.
*/
export const PrivateRoute: React.FC<PrivateRouteProps> = ({ component: Component, ...rest }) => {
  const isUserAuthenticated = useSelector(isUserAuthenticatedSelector);

  return (
    <Route
      {...rest}
      render={props => {
        const {
          location: { pathname: prevPath },
        } = props;

        if (isUserAuthenticated) {
          return <Component {...props} />;
        } else {
          return (
            <Redirect
              to={{
                pathname: PATHS.LOGIN,
                state: {
                  privateRouteRedirect: prevPath !== "/",
                  from: props.location,
                },
              }}
            />
          );
        }
      }}
    />
  );
};
